document.addEventListener('DOMContentLoaded', function () {
  // Form exists
  var form = document.querySelector('.warranty-register-form');
  if (!form) return;

  // No metafields: JS is minimal
  // Optional client-side validation can be added
});
